import  React, { useCallback } from 'react';

// DEPENDENCIES
import { useDispatch } from 'react-redux';

// GLOBAL FUNCTIONS
import { preferenceActions } from 'actions.js';
import { doCallback } from 'functions';

// CONTEXT
import { useReport, ReportContext } from '../helpers/getReportData';

// GLOBAL COMPONENTS
import Filters from 'parts/filters/Filters';

// MAIN COMPONENT
const ReportFilters = props => {

  // CONTEXT
  const {
    data,
    filters,
    updateFilter,
  } = useReport() || {};

  // RENDER
  return (
    <Filters
      data={data}
      filters={filters}
      updateFilter={updateFilter}
      {...props}
    />
 )
}

// DATE FILTER
const DateFilter = ({
  onUpdate,
  ...props
}) => {

  // REDUX
  const dispatch = useDispatch();

  // CALLBACKS
  const handeDateOptionChange = useCallback(
    ({ option }) => {
      dispatch(preferenceActions.updatePreference('reports', {
        dateFilterOption: option
      }))
    },
    [dispatch]
  )
  const handleUpdate = useCallback(
    preference => {
      doCallback(onUpdate, preference, 'reports')
    },
    [onUpdate]
  )

  // RENDER
  return <Filters.Date.Range {...props} onUpdate={handleUpdate} onDateOptionChange={handeDateOptionChange} />
}

// CHILD COMPONENTS
ReportFilters.Button        = Filters.Button;
ReportFilters.Select        = Filters.Select;
ReportFilters.Date          = DateFilter;
ReportFilters.Search        = Filters.Search;
ReportFilters.Spacer        = Filters.Spacer;
ReportFilters.Reset         = props => <Filters.Reset tableContext={ReportContext} {...props} />;

// EXPORT
export default ReportFilters;
